import { Component } from '@angular/core';
import { LayoutService } from '../../../core/services/layout.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent {
  constructor(
    public layoutService: LayoutService,
    private router: Router
  ) {}
}
